<div class="app app-main app-clean" [ngClass]="pageStyle">
  <router-outlet></router-outlet>
</div>
